import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePreferences } from "@/lib/preferences";
const ORDER = ["light", "dark", "system"];
const LABEL = {
    light: "Light",
    dark: "Dark",
    system: "System",
};
export function ThemeToggle({ compact = false }) {
    const { prefs, setPref } = usePreferences();
    function cycle() {
        const idx = ORDER.indexOf(prefs.theme);
        setPref("theme", ORDER[(idx + 1) % ORDER.length]);
    }
    return (_jsxs("button", { type: "button", onClick: cycle, title: `Theme: ${LABEL[prefs.theme]} (click to change)`, "aria-label": `Theme: ${LABEL[prefs.theme]}`, className: `inline-flex items-center gap-1 rounded-md ${compact ? "p-2" : "px-2.5 py-1.5"} text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800`, children: [_jsx(Icon, { theme: prefs.theme }), !compact && _jsx("span", { className: "text-sm", children: LABEL[prefs.theme] })] }));
}
function Icon({ theme }) {
    if (theme === "light") {
        return (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("circle", { cx: "12", cy: "12", r: "4", stroke: "currentColor", strokeWidth: "2" }), _jsx("path", { d: "M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })] }));
    }
    if (theme === "dark") {
        return (_jsx("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: _jsx("path", { d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z", stroke: "currentColor", strokeWidth: "2", strokeLinejoin: "round" }) }));
    }
    return (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("rect", { x: "3", y: "4", width: "18", height: "14", rx: "2", stroke: "currentColor", strokeWidth: "2" }), _jsx("path", { d: "M8 21h8M12 18v3", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })] }));
}
